<template>
  <div>
    <div class="summary-tables">
      <table class="summary-table">
        <tr :class="['check-row', { isOK: isCheckOK }]">
          <th>Status:</th>
          <td v-if="loadingFinished">{{ statusText }}</td>
        </tr>
      </table>
    </div>
    <div class="additional-content">
      <button @click="handleDbExport" :disabled="!isCheckOK || isLoadingDbExport">
        <span v-if="isLoadingDbExport" class="spinner-wrap">
          <span class="spinner"></span>
        </span>
        <span v-else>
          DB Upload
        </span>
      </button>
      <button @click="handlePdfExport" :disabled="!isCheckOK || isLoadingDbExport">
        <span v-if="isLoadingPdfExport" class="spinner-wrap">
          <span class="spinner"></span>
        </span>
        <span v-else>
          PDF Export
        </span>
      </button>
    </div>

    <div v-if="pdfUrl" class="pdf-download">
      <a :href="pdfUrl" target="_blank">📄 PDF herunterladen</a>
    </div>

    <div id="hot"></div>
  </div>
</template>

<script>
import PVDataTable from './PVDataTable.vue';
import axios from "axios";
import config from "@/config/config";

export default {
  name: 'PVDataTableStundenaufzeichnung',
  extends: PVDataTable,
  data() {
    return {
      isLoadingPdfExport: false,
      pdfUrl: null,
      check_hours: 0,
      isLoadingDbExport: false
    };
  },
  watch: {
    selectedWeek(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.check_hours = 0;
        this.pdfUrl = null;  // Hide PDF download button
      }
    },
    selectedYear(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.check_hours = 0;
        this.pdfUrl = null;  // Hide PDF download button
      }
    }
  },
  computed: {
    isCheckOK() {
      return this.check_hours.toFixed(2) === '38.50';
    },
    statusText() {
      return this.isCheckOK ? 'OK!' : 'FEHLER!';
    }
  },
  methods: {
    storeFetchedData(responseData) {
      // Call the original method to store table data
      this.data = responseData.data;
      this.columnConfig = responseData.columnConfig;
      this.columnTitles = responseData.columnTitles;
      this.sortOrder = responseData.sortOrder;
      this.sumRow = responseData.sumRow;
      this.fixedColumns = responseData.fixedColumns || 0;

      // Extract summary data from API response, if available
      if (responseData.check_hours) {
        this.check_hours = responseData.check_hours;
      }
    },
    async handleDbExport() {
      if (!this.data || this.data.length === 0) {
        this.$root.showToast('error', 'Keine Daten zum Exportieren vorhanden.');
        return;
      }

      this.isLoadingDbExport = true;

      const params = new URLSearchParams();
      params.append('year', this.selectedYear);
      params.append('week', this.selectedWeek);
      params.append('data', JSON.stringify(this.data)); // Use raw data directly

      try {
        const response = await axios.post(config.EXPORT_DB_URL, params);
        this.isLoadingDbExport = false;

        if (response.data.success) {
          this.$root.showToast('success', `Daten erfolgreich in die Datenbank exportiert! (Neu: ${response.data.data.inserted}, Aktualisiert: ${response.data.data.updated})`);
        } else {
          this.$root.showToast('error', response.data.error || 'Fehler beim DB-Export.');
        }
      } catch (error) {
        this.isLoadingDbExport = false;
        this.$root.showToast('error', `Fehler: ${error.message}`);
      }
    },
    async handlePdfExport() {
      if (!this.hotInstance) {
        this.$root.showToast('error', 'Tabelle nicht geladen.');
        return;
      }

      this.isLoadingPdfExport = true;

      // **Get formatted table data from Handsontable**
      const formattedData = this.hotInstance.getData()
          .map((row, rowIndex) => {
            return this.columnConfig.reduce((formattedRow, column, colIndex) => {
              formattedRow[column.data] = this.hotInstance.getCell(rowIndex, colIndex)?.innerText || row[colIndex];
              return formattedRow;
            }, {});
          });

      const params = new URLSearchParams();
      params.append('title', 'Stundenaufzeichnung');
      params.append('year', this.selectedYear);
      params.append('week', this.selectedWeek);
      params.append('data', JSON.stringify(formattedData)); // Send table data
      params.append('columnTitles', JSON.stringify(this.columnTitles)); // Send column titles directly

      try {
        const response = await axios.post(config.EXPORT_PDF_URL, params);
        this.isLoadingPdfExport = false;

        if (response.data.success) {
          this.pdfUrl = response.data.data.file_url;
          this.$root.showToast('success', 'PDF erfolgreich erstellt!');
        } else {
          this.$root.showToast('error', response.data.error || 'Fehler beim Export.');
        }
      } catch (error) {
        this.isLoadingPdfExport = false;
        this.$root.showToast('error', `Fehler: ${error.message}`);
      }
    }
  }
};
</script>

<style>
.additional-content {
  margin: 20px 0;
  display: flex;
  justify-content: center;
  gap: 20px;
}

.additional-content button {
  min-width: 180px;
  min-height: 40px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.additional-content button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.additional-content button:hover {
  background-color: #0056b3;
}

.additional-content button:hover:disabled {
  background-color: #6c757d;
}

.pdf-download {
  margin: 15px auto;
  text-align: center;
}

.pdf-download a {
  color: #007bff;
  font-weight: bold;
  text-decoration: none;
}

.pdf-download a:hover {
  text-decoration: underline;
}

.spinner-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  width: 10px;
  height: 10px;
  border: 1px solid white;
  border-top-color: transparent;
  border-radius: 50%;
  display: block;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.check-row {
  font-weight: bold;
  background-color: #f44343; /* Default color is red */
  color: white;
}

.check-row.isOK {
  background-color: #4caf50; /* Turns green when condition is met */
}
</style>